import { FC } from 'react'
import { Box, useTheme } from '@mui/material'
import SideNavMenuItem, { SideNavItem } from './SideNavMenuItem'
import { useLocation } from 'react-router-dom'

type SideNavProps = {
  sideNavItems?: SideNavItem[]
}

/**
 * Side navigation component that displays menu items in a vertical list.
 * Styled according to the theme's sidenav settings.
 */
const SideNav: FC<SideNavProps> = ({ sideNavItems }) => {
  const theme = useTheme()

  // find the current path, and if any of the sideNavItems have a path that matches the current path, set the active item
  const currentPath = useLocation().pathname

  const menuItems = sideNavItems?.map((item) => ({
    ...item,
    active: item.path === currentPath,
  }))

  return (
    <Box
      component="nav"
      sx={{
        width: theme.app.sidenavWidth,
        backgroundColor: theme.app.sidenavBackground,
        paddingTop: '16px',
        flexShrink: 0,
        alignSelf: 'stretch',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        component="ul"
        sx={{
          position: 'fixed',
          top: theme.loaded.pageHeaderHeight,
          width: theme.app.sidenavWidth,
          listStyle: 'none',
          margin: 0,
          padding: 0,
          flex: 1,
        }}
      >
        {menuItems?.map((item) => (
          <SideNavMenuItem key={item.path} item={item} />
        ))}
      </Box>
    </Box>
  )
}

export default SideNav
